import React, {  useEffect, useLayoutEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import RegionBranchMultipleSelectNew from 'component/branch/RegionBranchMultipleSelectNew'
import ContentHeader from 'component/utils/ContentHeader'
import * as paramsNexpActions from 'action/paramsNexp'
import FormField from 'component/paramsNexp/FormField'
import { CustomMenuList as MenuList } from 'component/reactSelect/CustomMenuList'
import { CustomMultiValue as MultiValueContainer } from 'component/reactSelect/CustomMultiValue'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Field from 'component/utils/Field'
import SuccessModal from 'component/Modal/SuccessModal'
import ErrorModal from 'component/Modal/ErrorModal'
import { isEmpty } from 'utils/validations'
import moment from 'moment'
import _ from 'lodash'

// Quantity of related materials
const RULE_15 = "15"

// Number of days to retroact
const RULE_16 = "16"
const inputListRegionsAndBranchsInitialState = {
  input: {
    checked: false,
    name: "listRgionsAndBranchs",
    value: []
  }
}

const fieldsInitialState = [{name: "params.nexp.materials", value: '', type: "lmexpress.items", slug: "nrMaterialQty"}, {name: "params.nexp.retroact.days", value: '', type: "irc.gama.labelDays", slug: "nrRetroactDay"}]
const ParamsNexp = ({translate,auth, saveNexp, savedNexp, updateNexp, fetchSections, resetParamsNexp}) => {


  useEffect(() => {

    if(!isEmpty(saveNexp.error)) {
      setShowError(true)
      setPrevValues([{}])
    }

    if(isEmpty(saveNexp.error ) && !saveNexp.isUpdating && saveNexp.success) {

      setShowSuccess(true)
    }

  }, [saveNexp])

  useEffect(() => {

    if(!isEmpty(savedNexp)) {
      const newFields = [{...fieldsInitialState[0], value: savedNexp.nrMaterialQty.toString()}, {...fieldsInitialState[1], value: savedNexp.nrRetroactDay.toString()}]
      setPrevValues(newFields)
      setFieldsState(newFields)

    }

  }, [savedNexp])


  // component will unmount
  useLayoutEffect(() => () => {
      resetParamsNexp()
    },[])

  const [showSuccess, setShowSuccess] = useState(false)
  const [prevValues, setPrevValues] = useState([{}])
  const [showError, setShowError] = useState(false)
  const [fieldsState, setFieldsState] = useState([{name: "params.nexp.materials", value: '', type: "lmexpress.items"}, {name: "params.nexp.retroact.days", value: '', type: "irc.gama.labelDays"}])
  const [listRegionsAndBranchs, setListRegionsAndBranchs] = useState({
    input: {
      checked: false,
      name: "listRegionsAndBranchs",
      value: []
    }
  })


  const mountBranchs = (branchValue) => ({
      idNexp: null,
      branchRegion: branchValue.value,
      dsBranchRegion: branchValue.label,
      inRegion: (!isEmpty(branchValue.idBranches) || !branchValue.isBranch) ? 1 : 0
    })


  const findSavedNexp = (branchValues) => {

    const nexpBranchsParam = branchValues.input.value.map(branch => mountBranchs(branch))
    const params = {
      wareHouseId: "C050",
      nexpBranchs: nexpBranchsParam
    }
    fetchSections(auth.user.dsToken, params)

  }

  const handleSubmit = () => {

    const nexpBranchsParam = listRegionsAndBranchs.input.value.map(branch => mountBranchs(branch))


    const nrMaterialQtyConfig = {
      ruleCode: RULE_15,
      ruleValue: fieldsState[0].value,
      isActive: true,
      rate: null


    }
    const nrRetroactDayConfig = {
      ruleCode: RULE_16,
      ruleValue: fieldsState[1].value,
      isActive: true,
      rate: null,


    }

    console.log('user: ', auth.user)
    const params = {
      dsYear: moment().year(),
      wareHouseId: "C050",
      nexpBranchs: nexpBranchsParam,
      nrMaterialQty: fieldsState[0].value,
      nrRetroactDay: fieldsState[1].value,
      nrRetroactDayParam: nrRetroactDayConfig,
      nrMaterialQtyParam: nrMaterialQtyConfig,
      cdLdap: auth.user.username,
      dsLdap: auth.user.fullName,

    }
    setPrevValues(fieldsState)
    updateNexp(auth.user.dsToken, params)
  }

  const hasRequiredEmpty= () => {

    if(fieldsState.filter(field => isEmpty(field.value)).length  > 0) return true
    if (!listRegionsAndBranchs.input.value || listRegionsAndBranchs.input.value.length === 0) return true
    return false

  }
  const sameValues = () => _.isEqual(prevValues, fieldsState)

  const clearForm = (withBranch = true) => {
    setFieldsState(fieldsInitialState)
    setPrevValues([{}])
    if(withBranch) branchChange([])
  }

  const branchChange = (values) => {


    const newInputList = {...inputListRegionsAndBranchsInitialState}
      newInputList.input.value = values
      setListRegionsAndBranchs(newInputList)
    if (
      values.length === 1 &&
      values[0].value !== 'all' &&
      values[0].isBranch !== undefined
    ) {
      // TODO - IMPLEMENT FIND FILTERS
      findSavedNexp(newInputList)
    }

    else  {
      clearForm(false)

    }
  }

  const setValueToField = (index,value) => {
      const newFields = fieldsState.map((field,indexMap) => index === indexMap ? {...field, value} : field )

      setFieldsState(newFields)

  }

  const mountFields = () => fieldsState.map((field,index) => <FormField
      key={field.name}
      index={index}
      label={field.name}
      rightLabel={field.type}
      field={field}
      setValueToField={setValueToField}
      translate={translate}

  />)

  return (
    <div className='irc'>
      <ContentHeader>{translate('params.nexp')}</ContentHeader>

      {showSuccess && (
        <SuccessModal
          handleClose={() => setShowSuccess(false)}
          msg={translate('params.supply.success')}
          size='sm'
          t={translate}
          center
          buttonText='OK'
          fillButton
        />
      )}

      {showError && (<ErrorModal
        size='sm'
        handleClose={() => setShowError(false)}
        msg={ translate('lmexpress.parameter.update-fail')}
        t={translate}
        center
        buttonText='OK'
        fillButton
      />)}

      <Col md={10} mdOffset={1}>
      <form className='GamaForm-new'>
      <fieldset>
          <Row>
            <div className='margin-bottom margin-left-small margin-right-small'>
              <Field {...listRegionsAndBranchs} >
                <h4 className='no-margin'>
                  <b>{translate('scheduleBlock.branchs')}</b>
                </h4>
                <RegionBranchMultipleSelectNew
                  required
                  id='listRegionsAndBranchs'
                  paramsSupply
                  {...listRegionsAndBranchs.input}
                  placeholder={translate('select.one.store')}
                  components={{ MenuList, MultiValueContainer }}
                  translate={translate}
                  onChange={(event) => {
                    const branchs = event.target.value
                    branchChange(branchs)
                  }}
                  excludeInactive={true}
                />
              </Field>
            </div>
          </Row>
          <Row>
            <Col xs={12}>
              <h4 className='no-margin'>
                <b>{translate('mobile.ponctual.title')}</b>
              </h4>
              <div className={'mobiCard'}>
                <table cellPadding='0' cellSpacing='0' className='new-table'>
                  <thead>
                    <tr>
                      <th scope={'col'} colSpan='1'>
                        {translate('parameter')}
                      </th>
                      <th colSpan='4'>
                        {translate('newPriceBannerFragment.values')}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {mountFields()}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
          <div style={{gap: "16px"}} className='margin-bottom  flex justify-content-end'>

              <button
                role='button'
                type='button'
                style={{width: '150px',  height: '44px'}}
                className='btn btn-danger-outline button-full'
                onClick={() => clearForm()}
                disabled={!listRegionsAndBranchs.input.value || listRegionsAndBranchs.input.value < 1}
              >
                {translate('button.clean')}
              </button>


              <button
                role='button'
                type='button'
                style={{width: '150px',  height: '44px'}}
                className='btn btn-primary button-full'
                disabled={hasRequiredEmpty() || sameValues()}
                onClick={handleSubmit}
              >
                {translate('save_button_label')}
              </button>

            </div>
        </fieldset>
      </form>

      </Col>

    </div>
  )



}


ParamsNexp.propTypes = {
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  saveNexp: PropTypes.object,
  updateNexp: PropTypes.func.isRequired,
  fetchSections: PropTypes.func.isRequired,
  savedNexp: PropTypes.object,
  resetParamsNexp: PropTypes.func.isRequired
}

const mapStateToProps = /* istanbul ignore next */ ({ nexpReducer }) => ({
  savedNexp: nexpReducer.get.record,
  saveNexp: nexpReducer.save,
})

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(paramsNexpActions, dispatch)

/* istanbul ignore next */
const ParamsNexpTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(ParamsNexp)

/* istanbul ignore next */
export default connect(mapStateToProps, mapDispatchToProps)(ParamsNexpTranslated)

export { ParamsNexp}
